import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import './inner-modal.scss';

const InnerModal = ({
  notAllow,
  allow,
  children,
  footer,
  title = {},
  onClose = null,
  notAllowId,
  allowId,
  modalType = '',
}) => {
  return (
    <Fragment>
      <div className="modal--shadow " onClick={onClose} />
      <section
        className={`modal${modalType === 'buy' ? ' modal--listing' : ''}`}
      >
        <main className="modal--content">
          {title && title.id && title.defaultMessage && (
            <ModalHeader title={title} onClose={onClose} />
          )}
          {children}
          {footer && (
            <ModalFooter
              notAllow={notAllow}
              allow={allow}
              notAllowId={notAllowId}
              allowId={allowId}
            />
          )}
        </main>
      </section>
    </Fragment>
  );
};

InnerModal.propTypes = {
  notAllow: PropTypes.func,
  allow: PropTypes.func,
  children: PropTypes.object,
  footer: PropTypes.bool,
  title: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string,
  }),
  onClose: PropTypes.func,
  notAllowId: PropTypes.string,
  allowId: PropTypes.string,
  modalType: PropTypes.string,
};

export default InnerModal;
